import { ADD_CYLINDER_DATA } from "../constants/action-types";

export const addCylinderData = (payload) => ({
  type: ADD_CYLINDER_DATA,
  payload,
});
